// extracted by mini-css-extract-plugin
export default {"root":"pHeIgC","title":"NLah18","carousel":"HC394v","arrow":"ukWY6Y","container":"UX2SqL"};